import { Link } from 'react-router-dom';

export default function SubscribeCta() {
  return (
    <section className="w-full px-4 md:px-10 py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto rounded-4xl bg-primary-500 overflow-hidden">
        <div className="relative px-6 md:px-12 py-10 md:py-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="max-w-2xl">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-background-50 leading-tight">
              不想一集一集追？订阅合集更新
            </h2>
            <p className="mt-3 text-sm md:text-base text-primary-50/90 leading-relaxed">
              每周我们会把新增和重点更新的专题整理成一封邮件，
              只发内容提醒，不啰嗦、不打扰。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href="#newsletter-form"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-700 text-sm label-font whitespace-nowrap hover:bg-accent-100 transition-colors"
            >
              <i className="ri-mail-send-line"></i>
              去订阅
            </a>
            <Link
              to="/collections"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-primary-200 text-background-50 text-sm label-font whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              先逛逛合集库
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}